package nl.volleyplanner.web

object IdGenerator {
    var startingId = 10000

    fun nextId() = startingId++
}